<template>
  <BaseDialog centered contentClass="delete-task-dialog" ref="dialog" :show-actions="false">
    <template slot="title">
      {{ $t('actions.delete') }}
    </template>
    <template slot="content">
      <form @click.prevent @keydown.enter.prevent>
        <div class="delete-task-dialog__message">
          {{ $t('opportunity-tasks.task-details.delete-confirm') }}
        </div>
        <div class="delete-task-dialog__task-name">
          {{ taskTitle }}
        </div>
        <div class="delete-task-dialog__actions">
          <BaseButton is-outlined @click.native="closeDialog">
            {{ $t('actions.cancel') }}
          </BaseButton>
          <BaseButton is-danger @click.native="onConfirm">
            {{ $t('actions.confirm') }}
          </BaseButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import BaseButton from '@/components/base/BaseButton.vue';

export default {
  name: 'DeleteTaskDialog',
  components: {
    BaseButton,
    BaseDialog,
  },
  data() {
    return {
      task: null,
    };
  },
  computed: {
    taskTitle() {
      return this.task ? this.task.title : '';
    },
  },
  methods: {
    openDialog(task) {
      this.task = task;
      this.$nextTick(() => {
        this.$refs.dialog.openModal();
      });
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onConfirm() {
      this.$emit('confirm');
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__delete-task-dialog {
  height: auto;
  width: 550px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }

  .close-icon__container {
    display: none;
  }
}

.delete-task-dialog {
  &__message {
    color: $color-normal;
    margin-bottom: 16px;
  }

  &__task-name {
    font-weight: 700;
    color: $color-normal;
    padding: 12px 16px;
    background: $color-neutral-pale;
    border-radius: $border-radius-root;
  }

  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
    gap: 12px;
  }
}
</style>
